var _mask, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5269_221",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_5269_221_clip_path)",
    "data-figma-skip-parse": "true",
    mask: "url(#path-1-inside-1_5269_221)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -0.007 0.007 0 7 7)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1428.57,
    y: -1428.57,
    width: 2857.14,
    height: 2857.14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(0, 0, 0, 0) 0deg,rgba(68, 26, 152, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H11C11 9.20914 9.20914 11 7 11V14V17C12.5228 17 17 12.5228 17 7H14ZM7 14V11C4.79086 11 3 9.20914 3 7H0H-3C-3 12.5228 1.47715 17 7 17V14ZM0 7H3C3 4.79086 4.79086 3 7 3V0V-3C1.47715 -3 -3 1.47715 -3 7H0ZM7 0V3C9.20914 3 11 4.79086 11 7H14H17C17 1.47715 12.5228 -3 7 -3V0Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.26666668057441711,\"g\":0.10196078568696976,\"b\":0.59607845544815063,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.26666668057441711,\"g\":0.10196078568696976,\"b\":0.59607845544815063,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-1.6400375591548062e-14,\"m01\":14.0,\"m02\":1.6400375591548062e-14,\"m10\":-14.0,\"m11\":-1.7954687826023281e-14,\"m12\":14.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-1-inside-1_5269_221)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_5269_221_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7H11C11 9.20914 9.20914 11 7 11V14V17C12.5228 17 17 12.5228 17 7H14ZM7 14V11C4.79086 11 3 9.20914 3 7H0H-3C-3 12.5228 1.47715 17 7 17V14ZM0 7H3C3 4.79086 4.79086 3 7 3V0V-3C1.47715 -3 -3 1.47715 -3 7H0ZM7 0V3C9.20914 3 11 4.79086 11 7H14H17C17 1.47715 12.5228 -3 7 -3V0Z",
    mask: "url(#path-1-inside-1_5269_221)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.941b89fbb8739dc116986cb6b9a716a4.svg";
export { ForwardRef as ReactComponent };